import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import CardamomImg from '../assets/banners/cardamons.jpg';
import { FaLeaf, FaGlobe, FaBoxOpen, FaWind } from 'react-icons/fa';

const Cardamom = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [email, setEmail] = useState('');

    const handleEnquiry = () => {
        const subject = encodeURIComponent("Cardamom Order Enquiry");
        const body = encodeURIComponent(
            `Hi,\n\nI am interested in placing an order or getting a quotation for your cardamom.\n\nPlease contact me back at: ${email}\n\nThanks,\n`
        );
        window.location.href = `mailto:yourmail@example.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-green-100 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl md:text-5xl font-bold text-green-700 mb-4">Premium Cardamom</h1>
                <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
                    Fresh, aromatic green cardamom pods — handpicked and naturally dried for exquisite flavor & fragrance.
                </p>
            </section>

            {/* Image and Details Section */}
            <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10 items-center">
                <div data-aos="zoom-in">
                    <img
                        src={CardamomImg}
                        alt="Cardamom"
                        className="rounded-xl shadow-xl"
                    />
                </div>
                <div data-aos="fade-left">
                    <h2 className="text-3xl font-semibold text-green-700 mb-6">Why Choose Our Cardamom?</h2>
                    <ul className="space-y-4 text-gray-700">
                        <li className="flex items-start gap-3"><FaLeaf className="text-green-600 mt-1" />Naturally grown & handpicked for premium quality</li>
                        <li className="flex items-start gap-3"><FaWind className="text-green-600 mt-1" />Rich aroma, intense flavor & vibrant green pods</li>
                        <li className="flex items-start gap-3"><FaBoxOpen className="text-green-600 mt-1" />Multiple grades & sizes: 6mm+, 7mm+, 8mm+</li>
                        <li className="flex items-start gap-3"><FaGlobe className="text-green-600 mt-1" />Ideal for tea blends, sweets, biryani, exports & gifting</li>
                        <li className="flex items-start gap-3"><FaLeaf className="text-green-600 mt-1" />No additives or chemical polishing</li>
                    </ul>
                </div>
            </section>

            {/* Specifications Section */}
            <section className="bg-green-50 py-14 px-4" data-aos="fade-up">
                <div className="max-w-5xl mx-auto">
                    <h3 className="text-3xl font-bold text-green-700 text-center mb-10">Product Specifications</h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <table className="w-full text-sm border border-green-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-green-200">
                                    <th className="p-4 text-left bg-green-100">Grades</th>
                                    <td className="p-4">6mm+, 7mm+, 8mm+, Bold Green</td>
                                </tr>
                                <tr className="border-b border-green-200">
                                    <th className="p-4 bg-green-100">Origin</th>
                                    <td className="p-4">India (Kerala, Sikkim), Guatemala</td>
                                </tr>
                                <tr className="border-b border-green-200">
                                    <th className="p-4 bg-green-100">Shelf Life</th>
                                    <td className="p-4">12-18 months</td>
                                </tr>
                                <tr className="border-b border-green-200">
                                    <th className="p-4 bg-green-100">Packaging</th>
                                    <td className="p-4">250g, 500g, 5kg, 10kg Pouches / Boxes</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-green-100">Moisture</th>
                                    <td className="p-4">Less than 10%</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="w-full text-sm border border-green-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-green-200">
                                    <th className="p-4 text-left bg-green-100">Nutritional Value (per 100g)</th>
                                    <td className="p-4">
                                        Calories: 311 kcal<br />
                                        Protein: 11g<br />
                                        Fat: 7g<br />
                                        Carbs: 68g<br />
                                        Fiber: 28g
                                    </td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-green-100">Usage</th>
                                    <td className="p-4">
                                        Chai Masala, Biryani, Desserts, Sweets, Perfume, Traditional Medicine
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Quality & Logistics Icons Section */}
            <section className="max-w-6xl mx-auto py-16 px-4 grid md:grid-cols-4 gap-6 text-center" data-aos="fade-up">
                <div>
                    <FaLeaf className="text-4xl mx-auto text-green-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Naturally Sourced</h4>
                </div>
                <div>
                    <FaWind className="text-4xl mx-auto text-green-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Strong Aroma</h4>
                </div>
                <div>
                    <FaGlobe className="text-4xl mx-auto text-green-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Worldwide Export</h4>
                </div>
                <div>
                    <FaBoxOpen className="text-4xl mx-auto text-green-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Secure Packaging</h4>
                </div>
            </section>

            {/* Enquiry Section */}
            <section className="bg-green-100 py-10 px-4" data-aos="fade-up">
                <div className="max-w-xl mx-auto text-center">
                    <h3 className="text-2xl font-bold text-green-800 mb-4">Send Us an Enquiry</h3>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email Address"
                        className="w-full p-3 rounded border border-green-300 mb-4 focus:outline-none"
                    />
                    <button
                        onClick={handleEnquiry}
                        className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg transition-all"
                    >
                        Send Enquiry
                    </button>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Cardamom;
